import React, { useEffect, useState } from 'react';

interface OffsetContentProps {
  children: React.ReactNode;
  offsetRatio?: number; // 0.33 means 1/3 of the way down
}

const OffsetContent: React.FC<OffsetContentProps> = ({ 
  children, 
  offsetRatio = 0.33 // Default to 1/3 of the way down
}) => {
  // Always use a fixed padding on first render (SSR and initial client render)
  const [topPadding, setTopPadding] = useState('0px');

  useEffect(() => {
    // Only run on client after mount
    const calculatePadding = () => {
      try {
        const viewportHeight = window.innerHeight;
        const headerElement = document.querySelector('header');
        const headerHeight = headerElement ? headerElement.offsetHeight : 40;
        const contentElement = document.getElementById('offset-content-inner');
        if (contentElement) {
          const contentHeight = contentElement.offsetHeight;
          const availableSpace = viewportHeight - headerHeight - contentHeight;
          if (availableSpace > 0) {
            const isMobile = window.innerWidth < 768;
            const ratio = isMobile ? Math.min(0.15, offsetRatio) : offsetRatio;
            const padding = Math.max(0, availableSpace * ratio);
            setTopPadding(`${padding}px`);
          } else {
            setTopPadding('20px');
          }
        }
      } catch {
        // Fallback: do nothing, keep default padding
      }
    };

    // Only run on client
    if (typeof window !== 'undefined') {
      calculatePadding();
      window.addEventListener('resize', calculatePadding);
      return () => {
        window.removeEventListener('resize', calculatePadding);
      };
    }
  }, [offsetRatio]);

  return (
    <div className="flex justify-center px-4 sm:px-6 lg:px-8" style={{ paddingTop: topPadding }}>
      <div id="offset-content-inner" className="w-full max-w-lg">
        {children}
      </div>
    </div>
  );
};

export default OffsetContent;
